import {createRouter, createWebHashHistory, createWebHistory} from "vue-router";

const routes = [
    {
        path: '/test',
        name: 'Test',
        component: () => import('../views/Test.vue')
    },
    {
        path: "/cloud/download",
        name: "Download",
        meta: {
            title: "common.link.share"
        },
        component: () => import('../views/Cloud/Download/index.vue')
    },
    {
        path: "/cloud/info",
        name: "Info",
        meta: {
            title: "common.share.content"
        },
        component: () => import('../views/Cloud/Download/Info.vue')
    },
    {
        path: "/login",
        name: "Login",
        meta: {
            title: "common.login",
            langKey: "common.login",
            noAuth: true,
        },
        component: () => import("../views/Login/Login.vue"),
    },
    {
        path: '/guide',
        name: "Guide",
        meta: {
            title: "common.share.guide",
            noAuth: true,
        },
        component: () => import('../views/FileDoc/view/HomeIndex.vue')
    },
    {
        path: '/settingguide',
        name: "SettingGuide",
        meta: {
            title: "common.setting.guide",
            noAuth: true,
        },
        component: () => import('../views/FileDoc/view/SettingIndex.vue')
    },
    {

        path: '/can',
        name: 'Can',
        component: () => import("@/components/Dashboard/ElCalender/index.vue"),
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../views/Register.vue"),
    },
    {
        path: "/forgetPassword",
        name: 'ForgetPassword',
        component: () => import('../views/ForgetPassword/index.vue')
    },
    {
        path: "/companyregister",
        name: "CompanyRegister",
        component: () => import("../views/CompanyRegister.vue"),
    },
    {
        path: "/",
        component: () => import("../layout/index.vue"),
        meta: {
            icon: "dashboard",
            title: "Index",
            langKey: "common.dashboard",
            signTab: true,
            uninclude: ["dir"],
        },
        redirect: `/dashboard`,
        children: [
            {
                path: 'notificationList',
                name: 'NotificationList',
                component: () => import('../views/NotificationList/index.vue'),
                children: [{
                    path: 'systemNotification',
                    name: 'SystemNotification',
                    component: () => import('../views/Study/SystemNotification.vue')
                }, {
                    path: "announcement",
                    name: 'Announcement',
                    component: () => import('../views/Study/Announcement.vue')
                }]
            },
            {path: "/success", name: 'Success', component: () => import('@/views/Success/Index.vue')},
            {
                path: "dashboard",
                name: "Dashboard",
                meta: {
                    title: "common.home",
                    langKey: "common.dashboard"
                },
                component: () => import("../views/Home/Dashboard.vue"),
            },
            {
                path: "marketing",
                name: "Marketing",
                meta: {
                    title: "sending.customer.group.text"
                },
                component: () => import("../views/Marketing/index.vue")
            },
            {
                path: "email",
                name: "Email",
                meta: {
                    title: "common.email"
                },
                component: () => import("../views/Email.vue"),
                redirect: `/email/inbox`,
                children: [
                    {
                        path: "systemPrompt",
                        name: "SystemPrompt",
                        meta: {
                            title: "common.system.tip"
                        },
                        component: () => import("../views/PositionStationDate.vue")
                    },
                    {
                        path: 'folder/:folderId',
                        name: "Folder",
                        meta: {
                            title: "common.folder"
                        },
                        component: () => import("../views/Mail/Folder.vue")
                    },
                    {
                        path: 'foldergroup',
                        name: "FolderGroup",
                        meta: {
                            title: "system.group.folder"
                        },
                        component: () => import("../views/Mail/FolderGroup.vue")
                    },
                    {
                        path: "group_setting",
                        name: "GroupSetting",
                        meta: {title: "common.team.management"},
                        component: () => import("../views/Group/index.vue"),
                    },
                    {
                        path: "account_setting",
                        name: "AccountSetting",
                        meta: {title: "common.setting.email"},
                        component: () => import("../views/AccountSetting.vue"),
                    },
                    {
                        path: "write_mail",
                        name: "WriteMail1_Mail",
                        meta: {
                            title: "common.email.sending"
                        },
                        component: () => import("../views/Mail/WriteMail.vue"),
                    },
                    // {
                    //     path: "send_all",
                    //     name: "Send_All",
                    //     meta: {
                    //         title: "common.email.group.send"
                    //     },
                    //     component: () => import('../views/Mail/SendAll.vue')
                    // },
                    {
                        path: "inbox",
                        name: "Inbox",
                        meta: {
                            title: "common.emailbox.receive",
                            keepAlive: true,
                        },
                        component: () => import("../views/Inbox.vue"),
                    },
                    {
                        path: "has_send",
                        name: "HasSend",
                        meta: {
                            title: "common.has.sent"
                        },
                        component: () => import("../views/HasSend.vue"),
                    },
                    {
                        path: "draft",
                        name: "Draft",
                        meta: {
                            title: "common.draftsbox"
                        },
                        component: () => import("../views/Draft.vue"),
                    },
                    {
                        path: "waste",
                        name: "Waste",
                        meta: {
                            title: "common.dustbin"
                        },
                        component: () => import("../views/Waste.vue"),
                    },
                    {
                        path: "examine",
                        name: "Examine",
                        meta: {
                            title: "common.email.examine"
                        },
                        component: () => import("../views/Mail/Examine.vue"),
                    },
                    {
                        path: 'follow_up',
                        name: 'FollowUp',
                        meta: {
                            title: "common.email.follow"
                        },
                        component: () => import("../views/Mail/FollowUp.vue"),
                    },
                    {
                        path: "customer",
                        name: "Customer",
                        meta: {
                            title: "common.customer"
                        },
                        children: [
                            {
                                path: "list",
                                name: "List",
                                meta: {
                                    title: "common_customer_list"
                                },
                                component: () => import("../views/Customer/List.vue"),
                            },
                            {
                                path: "public",
                                name: "Public",
                                meta: {
                                    title: "common.customer.public"
                                },
                                component: () => import("../views/Customer/Public.vue"),
                            },
                            {
                                path: "setting",
                                name: "Setting",
                                meta: {
                                    title: "common.customer.management"
                                },
                                component: () => import("../views/Customer/Setting.vue"),
                            },
                            {
                                path: "sending",
                                name: "Sending",
                                meta: {
                                    title: "sending.customer.group.text"
                                },
                                component: () => import("../views/SendGroup/Sending.vue"),
                            },
                            {
                                path: "senddetail/:massTaskId/:type/:taskId/:userId",
                                name: "SendDetail",
                                meta: {
                                    title: "common.sys.task.detail"
                                },
                                component: () => import("../views/SendGroup/SendingDetail.vue"),
                            },
                            {
                                path: "follow",
                                name: "Follow",
                                meta: {
                                    title: "common.customer.followup.remind"
                                },
                                component: () => import("../views/Customer/Follow.vue"),
                            },
                            {
                                path: "create",
                                name: "Create",
                                meta: {
                                    title: "common.khjd"
                                },
                                component: () => import("../views/Customer/Create.vue"),
                            },
                            {
                                path: `detail/:userId`,
                                name: "Detail",
                                meta: {
                                    title: "common.customer.details"
                                },
                                component: () => import("../views/Customer/Detail.vue"),
                            },
                        ],
                    },
                    {
                        path: 'detail/:id/:flag/:type',
                        name: "DetailEmail",
                        meta: {
                            title: "common.ph25"
                        },
                        component: () => import('../views/Mail/Detail.vue'),
                    }
                ],
            },
            {
                path: "/cloud",
                name: "Cloud",
                meta: {
                    title: 'common.file.cloud'
                },
                redirect: `/cloud/myfiles`,
                component: () => import("../views/Cloud/Cloud.vue"),
                children: [
                    {
                        path: 'myfiles',
                        name: "MyFiles",
                        meta: {
                            title: 'common.file.my'
                        },
                        component: () => import("../views/Cloud/Myfile/index.vue")
                    }, {
                        path: "shareme",
                        name: "ShareMe",
                        meta: {
                            title: 'common.file.joint'
                        },
                        component: () => import("../views/Cloud/ShareMe/index.vue")
                    }, {
                        path: "tos",
                        name: "ToShare",
                        meta: {
                            title: 'common.myjoint'
                        },
                        component: () => import("../views/Cloud/ToShare/index.vue")
                    }, {
                        path: "toshared",
                        name: "ToShared",
                        meta: {
                            title: 'common.myshare'
                        },
                        component: () => import("../views/Cloud/ToShared/index.vue")
                    }, {
                        path: "collect",
                        name: "Collect",
                        meta: {
                            title: 'common.cds14'
                        },
                        component: () => import("../views/Cloud/Collect/index.vue")
                    },
                    {
                        path: "recycle",
                        name: "Recycle",
                        meta: {
                            title: 'common.recycle'
                        },
                        component: () => import("../views/Cloud/Recycle/index.vue")
                    }]
            },
            // 聊天
            {
                path: '/chat',
                name: 'Chat',
                meta: {
                    title: 'chat.com'
                },
                component: () => import("../components/ChatNew/index.vue")
            },
            {
                path: "/messageDetail",
                name: "MessageDetail",
                component: () => import("../views/Study/MessageDetail.vue")
            }
        ],
    },
    {
        path: "/personal",
        name: "Personal",
        meta: {
            title: "common.account.center"
        },
        component: () => import("../views/UserCenter/index.vue"),
        children: [
            {
                path: 'childuser',
                name: 'ChildUser',
                component: () => import('../views/UserCenter/ChildUser.vue')
            },
            {
                path: 'qbasic',
                name: 'qbasic',
                component: () => import('../views/UserCenter/Qbasic.vue')
            },
            {
                path: 'qinfo',
                name: 'qinfo',
                meta: {
                    title: "common.qyxx"
                },
                component: () => import('../views/UserCenter/Qinfo.vue')
            },
            {
                path: "basic",
                name: "Basic",
                meta: {
                    title: "common.account.info"
                },
                component: () => import("../views/UserCenter/Basic.vue"),
            },
            {
                path: "station",
                name: "Station",
                meta: {
                    title: "common.team.station.detail"
                },
                component: () => import("../views/UserCenter/Station.vue"),
            },
            {
                path: "order",
                name: "Order",
                meta: {
                    title: "common.myorder"
                },
                component: () => import("../views/UserCenter/Order.vue"),
            },
            {
                path: "invoice",
                name: "Invoice",
                meta: {
                    title: "common.invoice.management"
                },
                component: () => import("../views/UserCenter/Invoice.vue"),
            },
            {
                path: "security",
                name: "Security",
                meta: {
                    title: "common.setting.security"
                },
                component: () => import("../views/UserCenter/Security.vue"),
            },
            {
                path: "repairOrder",
                name: "RepairOrder",
                meta: {
                    title: "common.cds42"
                },
                component: () => import("../views/UserCenter/RepairOrder.vue"),
            },
            {
                path: "editInfo",
                name: "EditInfo",
                component: () => import("../views/UserCenter/EditInfo.vue"),
            },
            {
                path: 'editQInfo',
                name: 'EditQInfo',
                component: () => import("../views/UserCenter/EditQInfo.vue")
            },
            {
                path: "setemail",
                name: "SetEmail",
                meta: {
                    title: "common.emailbox.bind"
                },
                component: () => import("../views/UserCenter/SetEmail.vue"),
            },
            {
                path: "setphone",
                meta: {
                    title: "common.bind.phone"
                },
                name: 'unBindPhone', component: () => import("../views/UserCenter/SetPhone.vue")
            },
            {
                path: "realName",
                name: "realName",
                component: () => import("../views/UserCenter/RealName.vue"),
            },
            {
                path: "applyOpen",
                name: "ApplyOpen",
                component: () => import("../views/UserCenter/ApplyOpen.vue"),
            },
            {
                path: "createdRepairOrder",
                name: "createdRepairOrder",
                component: () => import("../views/UserCenter/CreatedRepairOrder.vue"),
            },
            {
                path: "buystorage",
                name: "BuyStorage",
                component: () => import("../views/UserCenter/BuyStorage.vue"),
            },
            {
                path: 'storeDetails',
                name: "StoreDetails",
                meta: {
                    title: "common.ccxq"
                },
                component: () => import("../views/UserCenter/StoreDetails/Index.vue")
            },
            {
                path: 'edmDetails',
                name: "EdmDetails",
                meta: {
                    title: "common.edm.email.detail"
                },
                component: () => import("../views/UserCenter/EdmDetails/index.vue")
            },
            {
                path: 'aiDetails',
                name: "AiDetails",
                meta: {
                    title: "userinfo.vip.AI.detail"
                },
                component: () => import("../views/UserCenter/AIDetails/index.vue")
            },
            {
                path: 'flowDetails',
                name: "FlowDetails",
                component: () => import("../views/UserCenter/FlowDetails/Index.vue")
            }, {
                path: 'repairOrderDetails',
                name: 'RepairOrderDetails',
                meta: {
                    title: "common.workorder.detail"
                },
                component: () => import("../views/UserCenter/RepairOrderDetails.vue")
            }
            , {
                path: 'orderDetails',
                name: 'OrderDetails',
                component: () => import("../views/UserCenter/OrderDetails.vue")
            }, {
                path: 'invoiceDetails',
                name: 'InvoiceDetails',
                component: () => import("../views/UserCenter/InvoiceDetails.vue")
            }, {
                path: 'pay',
                name: 'Pay',
                component: () => import("../views/UserCenter/Pay.vue")
            }, {
                path: 'paySuccess',
                name: 'PaySuccess',
                component: () => import("../views/UserCenter/Pay/PaySuccess.vue")
            }
        ],
    },
    {
        path: "/showfile",
        name: "ShowFile",
        meta: {
            title: "common.preview"
        },
        component: () => import("../components/ShowTargetFile/showFile.vue")
    },
    {
        path: "/showtext",
        name: "ShowText",
        meta: {
            title: "common.preview"
        },
        component: () => import('../components/ShowTargetFile/showText.vue')
    },
    {
        path: "/showvideo",
        name: "ShowVideo",
        meta: {
            title: "common.preview"
        },
        component: () => import('../components/ShowTargetFile/showVideo.vue')
    },
    {
        path: "/showaudio",
        name: "ShowAudio",
        meta: {
            title: "common.preview"
        },
        component: () => import('../components/ShowTargetFile/showAudio.vue')
    },
    {
        path: "/filePreview",
        name: "FilePreview",
        meta: {
            title: "common.preview"
        },
        component: () => import('../components/FilePreview.vue')
    },


];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
